import React, { useState } from 'react';
import ClickableDiv from 'components/ClickableDiv';
import { Checkbox } from 'syngenta-digital-cropwise-react-ui-kit';
import FilterChevron from 'screens/Property/components/FilterChevron';
import PropTypes from 'prop-types';
import './index.css';

const farmsFilterDefaultPropFarms = [];
const farmsFilterDefaultPropSelectedFarmIds = [];
const FarmsFilter = ({
  farms = farmsFilterDefaultPropFarms,
  selectedFarmIds = farmsFilterDefaultPropSelectedFarmIds,
  onFarmSelect,
  showArchived = false
}) => {
  const [areOptionsVisible, setAreOptionsVisible] = useState(
    selectedFarmIds.length > 0
  );
  const hasArchivedFarms = farms.some(farm => farm.archived);

  return (
    <div className="farms-filter-container border-b border-neutral-100">
      <ClickableDiv
        className="property-filter-section-header flex justify-between items-center"
        onClick={() => setAreOptionsVisible(prevState => !prevState)}
      >
        <span className="text-black font-semibold">Farms</span>
        <FilterChevron open={areOptionsVisible} />
      </ClickableDiv>
      {areOptionsVisible ? (
        <div className="transition-all duration-200 overflow-y-hidden flex flex-col px-4 pb-5 gap-2">
          {farms
            .filter(farm => !farm.archived)
            .map(item => (
              <div className="property-filter-option-row" key={item?.id}>
                <Checkbox
                  className="property-filter-option"
                  checked={selectedFarmIds.includes(item?.id)}
                  onChange={onFarmSelect(item?.id)}
                >
                  {item?.name}
                </Checkbox>
              </div>
            ))}
          {showArchived && hasArchivedFarms && (
            <div className="mt-5 flex flex-col gap-2">
              <p className="text-neutral-60 mb-2">Archived Farms</p>
              {farms
                ?.filter(farm => farm.archived)
                .map(item => (
                  <div className="property-filter-option-row" key={item?.id}>
                    <Checkbox
                      className="property-filter-option"
                      checked={selectedFarmIds.includes(item?.id)}
                      onChange={onFarmSelect(item?.id)}
                    >
                      {item?.name}
                    </Checkbox>
                  </div>
                ))}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

FarmsFilter.propTypes = {
  farms: PropTypes.arrayOf(),
  selectedFarmIds: PropTypes.arrayOf(PropTypes.string),
  onFarmSelect: PropTypes.func.isRequired,
  showArchived: PropTypes.bool
};

export default FarmsFilter;
